export enum PermissionType{
    READ="R",
    MODIFY="M",
    ADD="A",
    DELETE="D"
}